// this file is generated by update_shopify_store_data.py at 2026-05-05 20:25:54.444169
var courses = [
    {
        "course_id": "20D41715-5ED0-F011-99A4-005056A7327D",
        "course_version": 2,
        "name": "Springer Publishing - CPN\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Certified Pediatric Nurse (CPN\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nCPN\u00ae is a registered trademark of the Pediatric Nursing Certification Board (PNCB). The PNCB does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to pediatric nursing practice and child development.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to pediatric patient-care scenarios across diverse health conditions.</li>\r\n    <li>Demonstrate readiness for the CPN&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Module 1: Certification Exam</li>\r\n    <li>Module 2: Growth and Development of Infants, Toddlers, and Preschoolers</li>\r\n    <li>Module 3: Growth and Development of School-Aged Children and Adolescents</li>\r\n    <li>Module 4: Eyes, Ears, Nose, and Throat Conditions</li>\r\n    <li>Module 5: Neurologic Conditions</li>\r\n    <li>Module 6: Respiratory Conditions</li>\r\n    <li>Module 7: Cardiovascular Conditions</li>\r\n    <li>Module 8: Hematologic and Oncologic Conditions</li>\r\n    <li>Module 9: Gastrointestinal and Nutritional Conditions</li>\r\n    <li>Module 10: Genitourinary, Renal, and Reproductive Conditions</li>\r\n    <li>Module 11: Musculoskeletal Conditions</li>\r\n    <li>Module 12: Endocrine and Metabolic Conditions</li>\r\n    <li>Module 13: Wounds, Burns, and Dermatologic Conditions</li>\r\n    <li>Module 14: Infectious Diseases and Immunizations</li>\r\n    <li>Module 15: Immunology and Allergies</li>\r\n    <li>Module 16: Behavioral and Psychosocial Conditions</li>\r\n    <li>Module 17: Special Developmental Needs</li>\r\n    <li>Module 18: Child Maltreatment and Neglect</li>\r\n    <li>Module 19: Emergencies, Trauma, and Poisonings</li>\r\n    <li>Module 20: Palliative and End-of-Life Care</li>\r\n    <li>Module 21: Professional Responsibilities and Ethics</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Child Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                "course_category_name": "Pediatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B262E546-23C9-E511-8771-005056B104B1",
                "course_category_name": "Adolescent Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];